export const INSTALLATIONS_URL = '/crud/installations/'
export const PLANS_URL = '/crud/plans/'
export const HOSPITALS_URL = '/crud/hospitals/'
export const USERS_URL = '/crud/users/'
export const SSO_REALMS_URL = '/crud/sso_realms/'
export const DRUGS_URL = '/crud/drugs/'
export const REPORTS_URL = '/reports/'
export const HOSPITAL_SUBSCRIPTIONS_URL = (hospitalId: string) => `/crud/hospitals/${hospitalId}/subscriptions`
export const REPORTS_DMA_CSV_URL = (drugId: string) =>
  `${REPORTS_URL}drug_model_access?drug_model_id=${drugId}&output=csv`
export const REPORTS_SE_CSV_URL = (startDate: string, endDate: string) =>
  `${REPORTS_URL}expiring_subscriptions?start_date=${startDate}&end_date=${endDate}&output=csv`
